import * as React from "react";
import { Button } from "@chakra-ui/react";
import { SuggestedPromptProps } from "./types";

export const SuggestedPrompt: React.FC<SuggestedPromptProps> = ({ text, onClick }) => (
  <Button variant="outline" size="xs" onClick={onClick} borderRadius="full">
    {text}
  </Button>
);
